import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui'
import { accountTypeWord } from '@/modules/projects/components/Workbench/accounts'
import {
  ACCOUNT_TYPES,
  type AccountType,
} from '@/modules/projects/components/Workbench/types'

const NO_TYPE = 'not_known'

export const TypeField = ({
  accountType,
  onPick,
}: {
  accountType: AccountType | null
  onPick: (accountType: AccountType | null) => void
}) => (
  <div className="space-y-1.5">
    <Label htmlFor="add-account-type">Type</Label>
    <Select
      value={accountType ?? NO_TYPE}
      onValueChange={(value) =>
        onPick(value === NO_TYPE ? null : (value as AccountType))
      }
    >
      <SelectTrigger id="add-account-type" className="w-56">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NO_TYPE}>{accountTypeWord(null)}</SelectItem>
        {ACCOUNT_TYPES.map((value) => (
          <SelectItem key={value} value={value}>
            {accountTypeWord(value)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
)
